import React from "react";

import { useTaskStatusCreation } from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props } from "./types";
import { Switch } from "./switch";
import { Form } from "./form";
import styles from "./styles.scss";

function StatusCreationForm({ project }: Props) {
  const { isRequestPending, createTaskStatus } = useTaskStatusCreation();

  return (
    <div className={styles.statusCreationForm}>
      <VisibilityWatcher>
        {(isVisible, show, hide) =>
          isVisible ? (
            <Form
              submit={(status) => {
                if (!isRequestPending) {
                  createTaskStatus({ project, status });
                  hide();
                }
              }}
            />
          ) : (
            <div className={styles.switch}>
              <Switch switch={show} />
            </div>
          )
        }
      </VisibilityWatcher>
    </div>
  );
}

export { StatusCreationForm };
